<script>
import moment from 'moment-timezone';
import {GET_WEEKLY_SCHEDULE, PUT_WEEKLY_SCHEDULE} from "@/core/services/store/tutor/tutor.module";

export default {
  name: "WeeklyWorkSchedule",
  props: {
    show: {type: Boolean, default: false},
    staff: {
      type: Object,
      default: () => ({code: "", name: "Lỗi không xác định", phone: "đã có lỗi"}),
    },

  },
  data() {
    return {
      baseSchedule: [
        {
          name: 'Sáng',
          shiftCode: 'morning',
          startTime: '08:00:00',
          endTime: '12:00:00',
          shiftId: 1,
          isFullWeek: false,
          days: [
            {day: 'thứ 2', nameFull: 'thứ hai', isWork: false, isDisable: false, dayOfWeek: 1},
            {day: 'thứ 3', nameFull: 'thứ ba', isWork: false, isDisable: false, dayOfWeek: 2},
            {day: 'thứ 4', nameFull: 'thứ tư', isWork: false, isDisable: false, dayOfWeek: 3},
            {day: 'thứ 5', nameFull: 'thứ năm', isWork: false, isDisable: false, dayOfWeek: 4},
            {day: 'thứ 6', nameFull: 'thứ sáu', isWork: false, isDisable: false, dayOfWeek: 5},
            {day: 'thứ 7', nameFull: 'thứ bảy', isWork: false, isDisable: false, dayOfWeek: 6},
            {day: 'Chủ nhật', nameFull: 'chủ nhật', isWork: false, isDisable: false, dayOfWeek: 0}
          ]
        },
        {
          name: 'Chiều',
          shiftId: 2,
          shiftCode: "afternoon",
          start_time: "13:30:00",
          end_time: "17:30:00",
          isFullWeek: false,
          days: [
            {day: 'thứ 2', nameFull: 'thứ hai', isWork: false, isDisable: false, dayOfWeek: 1},
            {day: 'thứ 3', nameFull: 'thứ ba', isWork: false, isDisable: false, dayOfWeek: 2},
            {day: 'thứ 4', nameFull: 'thứ tư', isWork: false, isDisable: false, dayOfWeek: 3},
            {day: 'thứ 5', nameFull: 'thứ năm', isWork: false, isDisable: false, dayOfWeek: 4},
            {day: 'thứ 6', nameFull: 'thứ sáu', isWork: false, isDisable: false, dayOfWeek: 5},
            {day: 'thứ 7', nameFull: 'thứ bảy', isWork: false, isDisable: false, dayOfWeek: 6},
            {day: 'Chủ nhật', nameFull: 'chủ nhật', isWork: false, isDisable: false, dayOfWeek: 0}
          ]
        },
        {
          name: 'Tối',
          shiftId: 3,
          shiftCode: "evening",
          startTime: "18:00:00",
          end_time: "22:00:00",
          isFullWeek: false,
          days: [
            {day: 'thứ 2', nameFull: 'thứ hai', isWork: false, isDisable: false, dayOfWeek: 1},
            {day: 'thứ 3', nameFull: 'thứ ba', isWork: false, isDisable: false, dayOfWeek: 2},
            {day: 'thứ 4', nameFull: 'thứ tư', isWork: false, isDisable: false, dayOfWeek: 3},
            {day: 'thứ 5', nameFull: 'thứ năm', isWork: false, isDisable: false, dayOfWeek: 4},
            {day: 'thứ 6', nameFull: 'thứ sáu', isWork: false, isDisable: false, dayOfWeek: 5},
            {day: 'thứ 7', nameFull: 'thứ bảy', isWork: false, isDisable: false, dayOfWeek: 6},
            {day: 'Chủ nhật', nameFull: 'chủ nhật', isWork: false, isDisable: false, dayOfWeek: 0}
          ]
        }
      ],
      internalShow: this.show,
      week: null,             // value của el-date-picker type="week" (là ngày Thứ 2)
      lastUpdatedAt: null,
      loading: false,
      apiData: null,
    };
  },
  mounted() {

  },
  computed: {
    weekDays() {
      if (!this.week) return [];
      const labels = ['Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7', 'Chủ nhật'];
      const monday = moment(this.week, 'YYYY-MM-DD', true).startOf('isoWeek');

      return labels.map((label, i) => {
        const d = monday.clone().add(i, 'days');
        return {
          label,
          display: d.format('DD/MM/YYYY'),
          raw: d.toDate(),
          date: d.format('YYYY-MM-DD')
        };
      });
    }
  },
  methods: {
    async onOpen() {
      const monday = moment().startOf('isoWeek');     // moment object
      this.week = monday.format('YYYY-MM-DD');
      await this.getWeeklySchedule()
    },
    close() {
      this.$bvModal.hide('work-schedule-modal')
    },
    async handleSubmit() {
      try {
        this.loading = true
        const fullDayNames = {
          "Thứ 2": "thứ hai",
          "Thứ 3": "thứ ba",
          "Thứ 4": "thứ tư",
          "Thứ 5": "thứ năm",
          "Thứ 6": "thứ sáu",
          "Thứ 7": "thứ bảy",
          "Chủ nhật": "chủ nhật"
        }
        this.apiData.schedules = this.weekDays.map((schedule) => {
          return {
            date: schedule.date,
            day_of_week: fullDayNames[schedule?.label],
            schedules: this.baseSchedule.flatMap((shift) => {
              return shift.days.filter((day) => day.nameFull === fullDayNames[schedule?.label] && (day.id || day.isWork)).map((day) => ({
                id: day.id,
                shift_id: shift.shiftId,
                shift_name: shift.name,
                shiftCode: shift.shiftCode,
                start_time: shift.startTime,
                end_time: shift.endTime,
                is_register: day.isWork,
                is_disabled: day.isDisable,
              }))
            })
          }
        })
        await this.$store.dispatch(PUT_WEEKLY_SCHEDULE, {id: this.staff?.id, payload: this.apiData})
        this.$message({
          showClose: true,
          message: 'Sửa lịch đi làm thành công',
          type: 'success'
        });
        await this.getWeeklySchedule()
      } catch (e) {
        console.log(e)
        this.$message({
          showClose: true,
          message: 'Sửa lịch đi làm thất bại',
          type: 'error'
        });
      } finally {
        this.loading = false
      }

    },
    formatWeekRange() {
      if (!this.week) return '';
      const m = moment(this.week, "YYYY-MM-DD");
      const monday = m.clone().startOf("isoWeek");
      const sunday = m.clone().endOf("isoWeek");
      return `${monday.format("DD/MM/YYYY")} - ${sunday.format("DD/MM/YYYY")}`;
    },
    handleCheckAll(isFullWeek, days) {
      days.forEach((day) => {
        day.isWork = day?.isDisable ? day?.isWork : isFullWeek
      })
    },
    handleChooseDay(shift) {
      shift.isFullWeek = shift.days.every(d => d.isDisable || d.isWork);
    },
    async getWeeklySchedule() {
      this.loading = true
      try {
        let data = await this.$store.dispatch(GET_WEEKLY_SCHEDULE, {
          credentials: {
            start_date: this.weekDays[0]?.date,
            end_date: this.weekDays[6]?.date
          },
          id: this.staff?.id
        })
        this.apiData = data?.data
        const schedules = data?.data?.schedules.flatMap((schedule) => {
          return schedule.schedules.map((shift) => ({
            date: schedule.date,
            dayOfWeek: moment(schedule.date).day(),
            ...shift
          }))
        }) ?? [];
        this.baseSchedule = this.baseSchedule.map((base) => {
          return {
            ...base, days: base.days.map((day, indexDay) => {
              const shift = schedules.find((schedule) => schedule.dayOfWeek === day.dayOfWeek && schedule?.shift_name === base.name)
              const isPastShift = this.isPastShiftMoment(this.weekDays[indexDay]?.date, base?.name)
              return {
                ...day,
                isWork: !!shift?.is_register,
                isDisable: isPastShift ? isPastShift : shift ? shift.is_disabled : false,
                id: shift?.id ?? null
              }
            })
          }
        })
        this.baseSchedule.forEach((shift) => {
          this.handleChooseDay(shift)
        })
      } catch (e) {
        this.$message({
          showClose: true,
          message: 'Đã có lỗi xẩy ra. Vui lòng thử lại',
          type: 'error',
          duration: 6000
        });
        this.close()
      } finally {
        this.loading = false
      }
    },
    isPastShiftMoment(dateStr, shift) {
      const shiftTimes = {
        "Sáng": "11:00",
        "Chiều": "16:30",
        "Tối": "21:00"
      };

      if (!shiftTimes[shift]) {
        return false
      }

      const shiftMoment = moment(`${dateStr} ${shiftTimes[shift]}`, "YYYY-MM-DD HH:mm");
      return shiftMoment.isBefore(moment());
    },
    formattedDate(date) {
      return moment(date).format("HH:mm DD/MM/YYYY");
    }
  }
}
</script>

<template>
  <b-modal
      id="work-schedule-modal"
      :title="'Lịch đi làm'"
      size="xl"
      :visible.sync="internalShow"
      hide-footer
      body-class="p-0"
      @show="onOpen"
  >
    <div v-if="loading" class="d-flex justify-content-center align-items-center" style="height:200px;">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div v-else class="p-4">
      <!-- Header form -->
      <div class="row">
        <div class="col-md-6">
          <label class="mb-1">Nhân sự Admin</label>
          <input
              class="form-control"
              :value="`${staff?.userId?+staff?.userId:''} - ${staff?.name} - ${staff?.phone}`"
              readonly
          />
        </div>
        <div class="col-md-6">
          <label class="mb-1">Tuần làm việc</label>
          <el-date-picker
              v-model="week"
              type="week"
              placeholder="Chọn tuần"
              :format="formatWeekRange()"
              value-format="yyyy-MM-dd"
              :picker-options="{ firstDayOfWeek: 1 }"
              class="w-100"
              @input="getWeeklySchedule()"
          />
        </div>
      </div>

      <!-- Bảng lịch -->
      <div class="mt-4">
        <div class="d-flex align-items-center mb-2">
          <strong class="mr-2">Lịch đi làm</strong>
          <small class="text-muted ml-auto">
            Cập nhật lần cuối lúc {{ formattedDate(apiData?.update_at) }}
          </small>
        </div>

        <div class="table-responsive schedule-table">
          <table class="table table-bordered text-center align-middle mb-0">
            <thead class="thead-light">
            <tr>
              <th class="align-middle" style="min-width:140px">Ca làm việc</th>
              <th class="align-middle" style="min-width:80px">Tất cả</th>
              <th v-for="(d, i) in weekDays" :key="'h'+i" class="align-middle" style="min-width:100px">
                <div>{{ d.label }}</div>
                <small class="text-muted">({{ d.display }})</small>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="shift in baseSchedule" :key="shift.name">
              <td>{{ shift.name }}</td>
              <td>
                <el-checkbox v-model="shift.isFullWeek" @change="handleCheckAll(shift.isFullWeek,shift.days)"
                ></el-checkbox>
              </td>
              <td v-for="day in shift.days">
                <el-tooltip v-if="day?.isDisable" placement="top"
                            content="Không thể thay đổi lịch những ca đã qua hoặc đã được gán tác vụ.">
                  <el-checkbox v-model="day.isWork" :disabled="true"></el-checkbox>
                </el-tooltip>
                <el-checkbox v-else v-model="day.isWork" :disabled="day?.isDisable"
                             @change="handleChooseDay(shift)"></el-checkbox>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <!-- Footer buttons -->
        <div class="d-flex justify-content-end p-3">
          <button class="btn btn-secondary mr-3" @click="close">Đóng</button>
          <button class="btn btn-primary" @click="handleSubmit">Sửa lịch</button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<style scoped>
.schedule-table .table thead th {
  background: #f7f7f7;
  vertical-align: middle;
}

.align-middle {
  vertical-align: middle !important;
}

.thead-light th {
  border-top: 1px solid #e9ecef;
  border-bottom: 1px solid #e9ecef;
}
</style>
